import React from "react";
import { getElementsInSection, getElementOrder } from "../Common/Utils/ElementsAndSectionUtils.js";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import AddElementsNotification from "./AddElementsNotification.jsx";
import SectionHeaderButton from "../Common/SectionHeaderButton";
import StaffSectionElementExpanded from "./StaffSectionElementExpanded";
import { StaffContainerHeader, SectionContainer, IndividualSectionList } from "../Common/Styles/StaffStyles";

export default function IndividualSection(
  {
    handleExpandSection,
    page,
    section,
    staffElements,
    setStaffElements,
    dialogue,
    setDialogue,
    sectionExpanded,
    characterFocus,
    setCharacterFocus,
    handleShowSectionModal,
    index,
  },
) {
  const isSectionExpanded = sectionExpanded.includes(section.sectionName);
  const elementsInSection = getElementsInSection(page, section);
  const elementOrderArray = section.elementOrderArray === undefined
    ? {}
    : section.elementOrderArray;
  const elementOrder = getElementOrder(elementOrderArray, elementsInSection, page);
  const elementDisplay = [
    ...elementOrder.filter((e) => elementsInSection.includes(e)),
    ...elementsInSection.filter((e) => !elementOrder.includes(e)),
  ];
 

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }
    if (destination.droppableId !== source.droppableId) {
      "Cannot drop in another section";
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    if (destination.droppableId === source.droppableId) {
      const newElementOrder = Array.from(
        elementDisplay.toSpliced(source.index, 1).toSpliced(
          destination.index,
          0,
          draggableId,
        ),
      );
      let nextElementOrderArray = { ...elementOrderArray };
      nextElementOrderArray[page] = newElementOrder;
      const nextSection = {
        ...section,
        elementOrderArray: nextElementOrderArray,
      };
      setStaffElements({
        ...staffElements,
        sections: staffElements.sections.map((s) =>
          s.sectionName === section.sectionName ? nextSection : s
        ),
      });
    }
  };
  return (
    <Draggable draggableId={section.sectionName} index={index}>
      {(provided,snapshot) => (
        <SectionContainer
          {...provided.draggableProps}
          ref={provided.innerRef}
          isDragging={snapshot.isDragging}
        >
          <StaffContainerHeader>
            <SectionHeaderButton
              dragHandleProps={provided.dragHandleProps}
              sectionName={section.sectionName}
              onClickAction={() => handleExpandSection(section.sectionName)}
              isSectionExpanded={isSectionExpanded}
            />
          </StaffContainerHeader>
          {section.elements.length > 0
            ? (
              <DragDropContext
                onDragEnd={onDragEnd}
              >
                <Droppable droppableId={section.sectionName}>
                  {(provided, snapshot) => (
                    <IndividualSectionList
                      rowIndex={index}
                      ref={provided.innerRef}
                      isDraggingOver={snapshot.isDraggingOver}
                      {...provided.droppableProps}
                    >
                      {elementDisplay
                        .map((element, index) => {
                          if (index === 0 || isSectionExpanded) {
                            return (
                              <StaffSectionElementExpanded
                                key={element}
                                staffElements={staffElements}
                                setStaffElements={setStaffElements}
                                element={element}
                                highlighted={false}
                                rowStyle={"staff-row-presentation"}
                                dialogue={dialogue}
                                setDialogue={setDialogue}
                                characterFocus={characterFocus}
                                setCharacterFocus={setCharacterFocus}
                                section={section}
                                page={page}
                                index={index}
                                isSectionExpanded={isSectionExpanded}
                              />
                            );
                          }
                        })}
                      {provided.placeholder}
                    </IndividualSectionList>
                  )}
                </Droppable>
              </DragDropContext>
            )
            : (
              <div className="staff-container">
                <AddElementsNotification
                  section={section}
                  handleShowSectionModal={handleShowSectionModal}
                />
              </div>
            )}
        </SectionContainer>
      )}
    </Draggable>
  );
}
